export default "__VITE_ASSET__bKVBoWvc__"